import * as Config from "effect/Config";
import * as ConfigProvider from "effect/ConfigProvider";
import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
import * as Option from "effect/Option";
import { AlchemyContext } from "../AlchemyContext.js";
import { AuthProviders } from "../Auth/AuthProvider.js";
import { CredentialsStoreLive } from "../Auth/Credentials.js";
import { ProfileLive, withProfileOverride } from "../Auth/Profile.js";
import { Stack } from "../Stack.js";
import { Stage } from "../Stage.js";
import { loadConfigProvider } from "../Util/ConfigProvider.js";
/** Query parameter carrying the JSON {@link SessionEnvironment} on session websockets. */
export const SESSION_ENV_PARAM = "alchemy-session-env";
export const encodeSessionEnvironment = (env) => JSON.stringify(env);
export const decodeSessionEnvironment = (raw) => JSON.parse(raw);
export const layer = (environment) => Layer.mergeAll(ProfileLive, CredentialsStoreLive, Layer.succeed(AuthProviders, {}), ConfigProvider.layer(loadConfigProvider(Option.fromNullishOr(environment.envFile)).pipe(Effect.map((base) => withProfileOverride(base, environment.profile)))), Layer.succeed(AlchemyContext, environment.alchemyContext), Layer.succeed(Stack, {
    name: environment.stack.name,
    stage: environment.stack.stage,
    resources: {},
    bindings: {},
    actions: {},
}), Layer.succeed(Stage, environment.stack.stage));
export const RPC_SERVER_ENVIRONMENT_KEY = "ALCHEMY_RPC_SERVER_ENVIRONMENT";
/** The spawn-time environment the parent baked into the child's process env. */
export const fromProcessEnv = Config.string(RPC_SERVER_ENVIRONMENT_KEY).pipe(Config.map((raw) => JSON.parse(raw)));
/**
 * Legacy single-stack boot: the full environment (including the stack) baked
 * into the process env at spawn time. Used by children that serve exactly one
 * stack for their whole lifetime (e.g. the Vite dev-server child, which gets
 * an explicit environment from `startViteChild`). RPC sidecars do NOT use
 * this — their sessions each carry a {@link SessionEnvironment}.
 */
export const fromEnv = () => Layer.unwrap(fromProcessEnv.pipe(Effect.flatMap((environment) => environment.stack === undefined ||
    environment.alchemyContext === undefined
    ? Effect.die(new Error(`${RPC_SERVER_ENVIRONMENT_KEY} carries no stack/alchemyContext — this child requires the legacy single-stack environment`))
    : Effect.succeed(layer({
        profile: environment.profile,
        envFile: environment.envFile,
        stack: environment.stack,
        alchemyContext: environment.alchemyContext,
    })))));
//# sourceMappingURL=RpcServerEnvironment.js.map